<template>
  <div class="details">
    <form-title>基本信息</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="机构名称">
            {{ result.agencyName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="负责人">
            {{ result.chargePersonName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="负责人电话">
            {{ result.chargePersonPhone }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="省市区">
            {{ result.provinceCityAreaName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="状态">
            <status :props="result.valid">
              {{ result.valid === types.INDENTITY_VALID_ENABLE ? '启用' : '禁用' }}
            </status>
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="机构座机">
            {{ result.agencyTelephone }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="创建人">
            {{ result.createName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="创建时间">
            {{ $time(Number(result.createTime)).format('YYYY/MM/DD HH:mm:ss') }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="累计报名数">
            {{ result.courseRegistrationCount }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="备注">
            {{ result.remark }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="营业执照">
            <el-image
              :src="result.businessLicense"
              :preview-src-list="[result.businessLicense]"
            />
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <form-title>人员信息</form-title>
    <div class="flex">
      <el-button-group class="switch-btns">
        <el-button
          :type="switchBtnKey?'primary':'default'"
          @click="switchBtnHandler(true)"
        >
          机构人员
        </el-button>
        <el-button
          :type="!switchBtnKey?'primary':'default'"
          @click="switchBtnHandler(false)"
        >
          机构辅导员
        </el-button>
      </el-button-group>
      <span>
        <el-button
          type="primary"
          @click="addAgencyIdentity"
        >新增{{ switchBtnKey?"人员":"辅导员" }}</el-button>
      </span>
    </div>
    <data-table
      :data="agencyTabelData"
      :pagination="pagination"
      :table-column="switchBtnKey ? agencyUserTableColumn : agencyCounselorTableColumn"
      @changeRadio="changeRadio"
      @buttonClick="buttonClick"
    />
    <form-title>修改记录</form-title>
    <data-table
      :data="tabelData"
      scroll
      :pagination="pagination"
      :table-column="logTableColumn"
    />
    <wx-user-info
      :dialog-visible.sync="dialogVisible"
      @getWxInfo="getWxInfo"
    />
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import infoItem from '@/components/common/infoItem.vue';
import formTitle from '@/components/common/formTitle.vue';
import dataTable from '@/components/common/dataTable.vue';
import wxUserInfo from '@/components/common/userWxInfo.vue';

import axClient from '@/services';
import types, { } from '@/config';
import status from '@/components/common/status.vue';

export default {
  name: 'AccountDetails',
  components: {
    formTitle,
    infoPanel,
    infoItem,
    status,
    dataTable,
    wxUserInfo,
  },
  data() {
    return {
      types,
      pagination: false,
      col: 5,
      result: {
        agencyUserList: [],
      },
      tabelData: [],
      pageNum: 1,
      pageSize: 9999,
      switchBtnKey: true,
      dialogVisible: false,
      logTableColumn: [
        {
          key: 'createByRealName',
          label: '操作者姓名',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'createByLoginName',
          label: '操作者机构',
          width: '160px',
          dataType: 'text',
        },
        {
          key: 'content',
          label: '修改信息',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'createTime',
          label: '修改时间',
          width: 'auto',
          dataType: 'time',
        },
      ],
      agencyUserTableColumn: [
        {
          key: 'isReceiveAccount',
          label: '状态',
          width: '60px',
          dataType: 'component',
          renderProps: '',
          render: () => 'radio',
        },
        {
          key: 'wechatNickName',
          label: '微信昵称',
          width: '160px',
          dataType: 'text',
        },
        {
          key: 'mobilePhone',
          label: '联系电话',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'identityValid',
          label: '状态',
          width: '80px',
          dataType: 'component',
          renderProps: { [types.INDENTITY_VALID_ENABLE]: '启用', [types.INDENTITY_VALID_DISABLE]: '禁用', successKey: types.INDENTITY_VALID_ENABLE },
          render: () => 'status',
        },
        {
          key: 'createByName',
          label: '创建人',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'identityCreateTime',
          label: '修改时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '170px',
          dataType: 'component',
          renderProps: [
            {
              text: '禁用', renderKey: types.INDENTITY_VALID_ENABLE, renderProp: 'identityValid', type: 'primary', eventIndex: 0, disableKey: null,
            },
            {
              text: '启用', renderKey: types.INDENTITY_VALID_DISABLE, renderProp: 'identityValid', type: 'primary', eventIndex: 0, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 1, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
      agencyCounselorTableColumn: [
        {
          key: 'userRealName',
          label: '人员姓名',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'mobilePhone',
          label: '联系电话',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'identityValid',
          label: '状态',
          width: '80px',
          dataType: 'component',
          renderProps: { [types.INDENTITY_VALID_ENABLE]: '启用', [types.INDENTITY_VALID_DISABLE]: '禁用', successKey: types.INDENTITY_VALID_ENABLE },
          render: () => 'status',
        },
        {
          key: 'identityCreateTime',
          label: '修改时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '170px',
          dataType: 'component',
          renderProps: [
            {
              text: '禁用', renderKey: types.INDENTITY_VALID_ENABLE, renderProp: 'identityValid', type: 'primary', eventIndex: 0, disableKey: null,
            },
            {
              text: '启用', renderKey: types.INDENTITY_VALID_DISABLE, renderProp: 'identityValid', type: 'primary', eventIndex: 0, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 1, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  computed: {
    agencyTabelData() {
      if (this.switchBtnKey && this.result) {
        return this.result.agencyUserList;
      }
      return this.result.agencyCounselorList;
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 获取查询的微信人员信息
    getWxInfo(data) {
      const { id } = data;
      const res = axClient.agency.insertAgencyIdentity({
        agencyId: this.$route.params.id,
        userId: id,
      });
      if (res) {
        this.$message.success('新增机构人员成功');
      }
      this.getInfo();
    },
    // 新增人员
    addAgencyIdentity() {
      this.dialogVisible = true;
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        case 1:
          this.deleteAccount(item);
          break;
        default:
          break;
      }
    },
    // 禁用/启用 机构
    confirmDialog(item) {
      this.$confirm('确定禁用/启用该机构人员？', '禁用/启用机构人员', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async () => {
        const { identityId, identityValid } = item;
        const data = await axClient.account.updateEntityValid(
          {
            identityId,
            identityValid: identityValid === types.INDENTITY_VALID_ENABLE
              ? types.INDENTITY_VALID_DISABLE : types.INDENTITY_VALID_ENABLE,
          },
        );
        if (data) {
          this.$message.success('启用/禁用成功');
          this.getInfo();
        }
      });
    },
    // 删除机构
    deleteAccount(item) {
      this.$confirm('确定删除该机构人员？', '删除机构人员', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async () => {
        const { identityId } = item;
        const data = await axClient.agency.deleteAgencyIdentity(
          {
            identityId,
          },
        );
        if (data) {
          this.$message.success('删除成功');
          this.getInfo();
        }
      });
    },
    // 切换显示机构人员
    switchBtnHandler(val) {
      this.switchBtnKey = val;
    },
    // 设置收款机构
    async changeRadio(item) {
      const { identityId } = item;
      const data = await axClient.agency.updateIsReceiveAccount({
        agencyId: this.$route.params.id,
        identityId,
      });
      if (data) {
        this.$message.success('设置成功');
        this.getInfo();
      }
    },
    // 详情
    async getInfo() {
      this.result = await axClient.agency.getInfo(this.$route.params.id);
      const result = await axClient.common.getLog({
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        targetId: this.result.id,
        targetType: 20,
      });
      this.tabelData = result.list;
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .title {
    margin-top: 12px;
  }
  .switch-btns {
    padding-bottom: 20px;
  }
}
</style>